import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { ModalStyled } from '../../../../theme/customizedStyleComponents';
import PatientMedicationDetails from './patientMedicationDetails';

export default class AddPatientMedication extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ModalStyled size="lg" show={this.props.show} onHide={this.props.handleClose} backdrop="static">
                <Modal.Header closeButton>
                    <Modal.Title>Add Patient Medication</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PatientMedicationDetails
                        patientId={this.props.patientId}
                        handleClose={this.props.handleClose}
                        refreshGrid={this.props.refreshGrid}
                        isNew={true}
                    />
                </Modal.Body>
            </ModalStyled>
        );
    }
}
